import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67bbcad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = {
  key: 1,
  class: "animate lesson-container"
}
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_4 = {
  key: 0,
  class: "loading-container big"
}
const _hoisted_5 = {
  key: 1,
  style: {"width":"100%","background-color":"#333","border-radius":"10px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","align-items":"center","position":"relative","width":"100% !important"}
}
const _hoisted_8 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","position":"relative","width":"100% !important"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "animate",
  style: {"width":"100%"}
}
const _hoisted_13 = {
  key: 0,
  class: "loading-container big"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "img"
}
const _hoisted_16 = {
  key: 1,
  class: "img"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_18 = {
  key: 2,
  class: "summary"
}
const _hoisted_19 = { class: "topic-header" }
const _hoisted_20 = { class: "animate" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 3,
  class: "notes-container"
}
const _hoisted_23 = {
  key: 0,
  class: "notes"
}
const _hoisted_24 = {
  key: 0,
  style: {"color":"#00007f","font-family":"'note-text'"}
}
const _hoisted_25 = {
  key: 0,
  class: "textarea-container"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "advice" }, "Toma aquí las notas que desees sobre la lección. Así podrás consultarlas siempre que quieras, tanto desde aquí como desde tu sección: Mis apuntes.", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_28 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Accede a tu cuenta para tomar apuntes de esta lección.", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 4,
  class: "notes-container-course"
}
const _hoisted_33 = { class: "notes-course" }
const _hoisted_34 = { class: "textarea-container" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "advice" }, "Conoce más sobre esta fantástica formación.", -1))
const _hoisted_36 = { class: "author-info" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  width: "25",
  class: "author-img"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = {
  key: 5,
  class: "notes-container-course"
}
const _hoisted_42 = {
  class: "notes-course",
  style: {"margin-top":"40px"}
}
const _hoisted_43 = { class: "textarea-container" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "advice" }, "¿Qué vamos a aprender hoy?", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_46 = ["innerHTML"]

import { ref, onMounted } from 'vue'

import CourseService from '@/services/CourseService'
import LessonService from '@/services/LessonService'
import YouTube from 'vue3-youtube'
import LessonsBtns from '@/components/widgets/LessonBtns.vue'
import LessonChecker from '../widgets/LessonChecker.vue'
import { useAuth } from '@/store/useAuth'
import NoteService from '@/services/NoteService'
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import { useRoute } from 'vue-router'
import useWindowWidth from '@/composables/useWindowWidth'
import main from '@/data/main.js'
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'LessonViewer',
  props: ['courseId', 'authorInfo', 'courseDescription'],
  emits: ['refreshStatus'],
  setup(__props, { emit: __emit }) {

const { windowWidth } = useWindowWidth()
const props = __props
const emit = __emit
const loading = ref(true)
const showSaveNoteAlt = ref(false)
const showPaperNotes = ref(false)
const store = useAuth()
const courseService = new CourseService()
const lessonService = new LessonService()
const noteService = new NoteService()
const toast = useToast()

const showMainDescription = ref(false)
const showLessonDescription = ref(false)

const notes = ref('')
const course = ref()
const lesson = ref()
const lessons = ref()
const lessonLoading = ref(false)
const lessonChecker = ref(null)
const lessonChecker0 = ref(null)
const lessonChecker1 = ref(null)
const lessonChecker2 = ref(null)
const lessonChecker3 = ref(null)
const lessonChecker4 = ref(null)
const lessonChecker5 = ref(null)
const notesLoading = ref(false)
const route = useRoute()
const ytLoaded = ref(false)
const showSummary = ref(false)
const currentLesson = ref(0)

const goNextEvent = () => {
    showLessonDescription.value = false
    showSummary.value = false
    showMainDescription.value = false
    showPaperNotes.value = false
    goNext()
}
const goPrevEvent = () => {
    showLessonDescription.value = false
    showSummary.value = false
    showMainDescription.value = false
    showPaperNotes.value = false
    goPrev()
}
const showLessonDescriptionEvent = () => {
    showLessonDescription.value = true
    showSummary.value = false
    showMainDescription.value = false
    showPaperNotes.value = false
}

const showDescriptionEvent = () => {
    showMainDescription.value = true
    showSummary.value = false
    showLessonDescription.value = false
    showPaperNotes.value = false
}

const showPaperNotesEvent = () => { 
    showPaperNotes.value = true
    showSummary.value = false
    showLessonDescription.value = false
    showMainDescription.value = false
}
const showSummaryEvent = () => {
    showSummary.value = true
    showLessonDescription.value = false
    showMainDescription.value = false
    showPaperNotes.value = false
}


onMounted(async () => {
    loading.value = true
    course.value = await courseService.GetCourse(props.courseId)
    lessons.value = await lessonService.getLessonsFromCourse(props.courseId)

    if (route.params.lesson_id) {
        handleLesson(parseInt(route.params.lesson_id.toString()))
    }
    loading.value = false
})

const onReady = () => {
    ytLoaded.value = true
}

const goPrev = async () => {
    showSummary.value = false
    lessonLoading.value = true

    const prev = await lessonService.getPrevLesson(currentLesson.value)
    if(prev.success == false) {
        lessonLoading.value = false
        notesLoading.value = false
        toast.showToast("No hay más clases en esa dirección.", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000)
        return
    }
    handleLesson(prev.id)
}

const goNext = async () => {
    showSummary.value = false
    lessonLoading.value = true

    const next = await lessonService.getNextLesson(currentLesson.value)
    if(next.success == false) {
        lessonLoading.value = false
        notesLoading.value = false
        toast.showToast("No hay más clases en esa dirección.", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000)
        return
    }
    handleLesson(next.id)
}

const handleLesson = async (lesson_id: number) => {
    showSummary.value = false
    lessonLoading.value = true
    notesLoading.value = true
    lesson.value = await lessonService.getLesson(lesson_id)
    currentLesson.value = lesson_id
    
    if (store.token) {
        const response = await noteService.GetNoteFromLesson(store.token, lesson.value.id)
        notes.value = response.note_content
    }
    window.scrollTo(0, 0);
    lessonLoading.value = false
    notesLoading.value = false

    setTimeout(async () => {
    if (!ytLoaded.value) {
        loading.value = true
        course.value = await courseService.GetCourse(props.courseId)
        lessons.value = await lessonService.getLessonsFromCourse(props.courseId)

        if (route.params.lesson_id) {
            handleLesson(parseInt(route.params.lesson_id.toString()))
        }
        loading.value = false
    }
}, 2000);
}

const handleUpdateNote = async () => {
    if (!store.token) {
        return
    }
    notesLoading.value = true
    const response = await noteService.CreateOrUpdateNote(store.token, lesson.value.id, notes.value)
    toast.showToast("Apuntes guardados.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000)
    notesLoading.value = false
}

const refreshStatus = async () => {
    emit('refreshStatus')
    if (lessonChecker0.value != null) {
        lessonChecker0.value.updateStatus()
    }
    if (lessonChecker1.value != null) {
        lessonChecker1.value.updateStatus()
    }
    if (lessonChecker2.value != null) {
        lessonChecker2.value.updateStatus()
    }
    if (lessonChecker3.value != null) {
        lessonChecker3.value.updateStatus()
    }
    if (lessonChecker4.value != null) {
        lessonChecker4.value.updateStatus()
    }
    if (lessonChecker5.value != null) {
        lessonChecker5.value.updateStatus()
    }
    if (lessonChecker.value != null) {
        lessonChecker.value.forEach(async (bullet) => {
            await bullet.updateStatus()
        });
    }
    Promise.all()
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon",
          scale: "2"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (lesson.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (lessonLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_icon, {
                      name: "ri-loader-2-fill",
                      animation: "spin",
                      class: "icon",
                      scale: "5"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    (lesson.value.videoURL && _unref(main).module_streaming_platform == 'youtube')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_unref(windowWidth) > 950)
                            ? (_openBlock(), _createBlock(_unref(YouTube), {
                                key: 0,
                                src: lesson.value.videoURL,
                                onReady: onReady,
                                class: "yt",
                                id: "ytube",
                                style: {"width":"100% !important"}
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createBlock(_unref(YouTube), {
                                key: 1,
                                src: lesson.value.videoURL,
                                class: "yt",
                                height: "180",
                                width: "280",
                                onReady: onReady
                              }, null, 8, ["src"]))
                        ]))
                      : _createCommentVNode("", true),
                    (lesson.value.videoURL && _unref(main).module_streaming_platform != 'youtube')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_unref(windowWidth) > 950)
                            ? (_openBlock(), _createElementBlock("iframe", {
                                key: 0,
                                src: lesson.value.videoURL,
                                style: {"width":"95% !important"}
                              }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true),
                          (_unref(windowWidth) < 950)
                            ? (_openBlock(), _createElementBlock("iframe", {
                                key: 1,
                                src: lesson.value.videoURL,
                                height: "180",
                                width: "280"
                              }, null, 8, _hoisted_10))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    _createVNode(LessonsBtns, {
                      lessonId: lesson.value.id,
                      onRefreshStatus: refreshStatus,
                      onGoPrev: goPrevEvent,
                      onGoNext: goNextEvent,
                      onShowNotes: showPaperNotesEvent,
                      onShowDescription: showDescriptionEvent,
                      onShowLessonDescription: showLessonDescriptionEvent,
                      onShowSummary: showSummaryEvent
                    }, null, 8, ["lessonId"])
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (lessonLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_icon, {
                      name: "ri-loader-2-fill",
                      animation: "spin",
                      class: "icon"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("button", {
                      onClick: showSummaryEvent,
                      class: "start"
                    }, "Acceder al contenido"),
                    (_unref(windowWidth) > 950)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_15, null, 512)), [
                          [_directive_lazy, { src: course.value.imageURL, loading: '../../img/lms/loading.png' }]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_16, null, 512)), [
                          [_directive_lazy, { src: course.value.imageURL, loading: '../../img/lms/loading.png' }]
                        ])
                  ]))
            ])),
        _hoisted_17,
        (showSummary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("h4", _hoisted_19, [
                _createTextVNode("TEMARIO "),
                _createElementVNode("button", {
                  class: "close-summary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showSummary.value = false))
                }, [
                  _createVNode(_component_v_icon, { name: "ri-close-circle-fill" })
                ])
              ]),
              _createElementVNode("ul", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lessons.value, (lesson) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: lesson.id,
                    onClick: ($event: any) => (handleLesson(lesson.id)),
                    class: "lesson-link"
                  }, [
                    _createVNode(LessonChecker, {
                      lessonId: lesson.id,
                      ref_for: true,
                      ref_key: "lessonChecker",
                      ref: lessonChecker
                    }, null, 8, ["lessonId"]),
                    _createTextVNode("#" + _toDisplayString(lesson.order) + " " + _toDisplayString(lesson.name), 1)
                  ], 8, _hoisted_21))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (lesson.value && showPaperNotes.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_unref(store).token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("h3", null, [
                      _createTextVNode("Mis apuntes "),
                      _createElementVNode("button", {
                        class: "close-note",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPaperNotes.value=false))
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "ri-close-circle-fill",
                          fill: "#00007f",
                          scale: "1.5",
                          style: {"cursor":"pointer"}
                        })
                      ]),
                      _createTextVNode(),
                      _createElementVNode("button", {
                        class: "save-note",
                        onClick: handleUpdateNote,
                        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (showSaveNoteAlt.value=true)),
                        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (showSaveNoteAlt.value=false))
                      }, [
                        (showSaveNoteAlt.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Guardar / Actualizar apuntes"))
                          : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createVNode(_component_v_icon, {
                          name: "md-save-sharp",
                          fill: "#00007f",
                          scale: "1.5",
                          style: {"cursor":"pointer"}
                        })
                      ], 32)
                    ]),
                    (!notesLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _hoisted_26,
                          _hoisted_27,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((notes).value = $event)),
                            class: "note-content"
                          }, null, 512), [
                            [_vModelText, notes.value]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_component_v_icon, {
                            name: "ri-loader-2-fill",
                            animation: "spin",
                            class: "icon",
                            scale: "5"
                          })
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
            ]))
          : _createCommentVNode("", true),
        (lesson.value && showMainDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("h3", null, [
                  _createTextVNode("Sobre este Curso "),
                  _createElementVNode("button", {
                    class: "close-note",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showMainDescription.value=false))
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "ri-close-circle-fill",
                      fill: "#00007f",
                      scale: "1.5",
                      style: {"cursor":"pointer"}
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("p", _hoisted_36, [
                    _createElementVNode("a", {
                      href: __props.authorInfo.channelURL,
                      target: "_blank",
                      class: "author-link"
                    }, [
                      _withDirectives(_createElementVNode("img", _hoisted_38, null, 512), [
                        [_directive_lazy, { src: __props.authorInfo.imageURL, loading: '../../../img/lms/loading.png' }]
                      ]),
                      _createTextVNode(" Realizado por " + _toDisplayString(__props.authorInfo.name), 1)
                    ], 8, _hoisted_37)
                  ]),
                  _hoisted_39,
                  (lesson.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "note-content",
                        style: {"color":"#00007f !important"},
                        innerHTML: props.courseDescription
                      }, null, 8, _hoisted_40))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (lesson.value && showLessonDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h3", null, [
                  _createTextVNode("#" + _toDisplayString(lesson.value.order) + " " + _toDisplayString(lesson.value.name), 1),
                  _createElementVNode("button", {
                    class: "close-note",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showLessonDescription.value=false))
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "ri-close-circle-fill",
                      fill: "#00007f",
                      scale: "1.5",
                      style: {"cursor":"pointer"}
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _hoisted_45,
                  (lesson.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: lesson.value.description,
                        class: "note-content",
                        style: {"color":"#00007f !important"}
                      }, null, 8, _hoisted_46))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})